module.exports = __webpack_public_path__ + "static/media/map3.40d70676.jpg";